<template>
  <el-row>
    <el-col :span="24">
      <div class="form-module-tit">{{ $locale("global.basicInfo") }}</div>

      <el-form-item :label="$locale('global.titleOfWork')" prop="name">
        <!-- <el-autocomplete
          v-model="formData.name"
          :fetch-suggestions="movieNameQuery"
          :placeholder="$locale('movie.plsEnterMovieName')"
          @select="selectMovieName"
          @input="changeMovieName"
          :maxlength="255"
        ></el-autocomplete> -->
        <RemoteSelectV2
          ref="selectV2"
          type="movie"
          :isForCP2="true"
          v-model="formData.name"
          :formValue.sync="formData.name"
          :list="comMovieList"
          @setList="arr => comMovieList = arr"
          :isMultiple="false"
          @change="selectMovieName"
          :placeholder="$locale('movie.plsEnterMovieName')"
        />
      </el-form-item>
      <el-form-item :label="$locale('movie.slogan')" prop="slogan">
        <el-input
          :placeholder="$locale('movie.sloganPlsInput')"
          v-model="formData.slogan"
          maxlength="32"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$locale('movie.movieLength')" prop="durationMin">
        <el-input
          :placeholder="$locale('movie.plsEnterMovieLength')"
          v-model.number="formData.durationMin"
          maxlength="5"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$locale('movie.movieTrailerLength')" prop="trailerTimeMin">
        <el-input
          :placeholder="$locale('movie.plsEnterMovieTrailerLength')"
          v-model.number="formData.trailerTimeMin"
          maxlength="5"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$locale('movie.releaseDate')" prop="" :required="true">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item prop="openDateType">
              <el-select v-model="formData.openDateType" @change="openDateTypeChangeAction">
                <el-option
                  v-for="option in releaseDateTypeOptions"
                  :value="option.value"
                  :label="option.label"
                  :key="option.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item prop="releaseTime" v-if="formData.openDateType === releaseDateTypeOptions[0].value">
              <CommDatePicker v-model="formData.releaseTime" :value.sync="formData.releaseTime" width="100%" />
            </el-form-item>

            <el-form-item prop="openDateStr" v-if="formData.openDateType === releaseDateTypeOptions[1].value">
              <el-input v-model="formData.openDateStr"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form-item>
      <el-form-item :label="$locale('movie.workRemarks')" prop="versionMasterMsg">
        <el-input
          :placeholder="$locale('movie.plsEnterWorkRemarks')"
          v-model="formData.versionMasterMsg"
          maxlength="255"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$locale('movie.id')" prop="filmSearchId">
        <el-input :placeholder="$locale('movie.plsEnterID')" v-model="formData.filmSearchId" maxlength="255"></el-input>
      </el-form-item>
      <hr class="dotted" />
    </el-col>
  </el-row>
</template>

<script>
import {
  initFormData,
  releaseDateTypeOptions,
} from "@/assets/js/movieStatic";
import CommDatePicker from "@/components/common/CommDatePicker";
import RemoteSelectV2 from "@/components/common/RemoteSelect-v2";
import { getMovieDetail } from "@/helpers/service/api/movie.js";

export default {
  name: "basic-info",
  components: {
    CommDatePicker,
    RemoteSelectV2
  },
  props: {
    formData: {
      required: true,
      type: Object,
    },
    formRef: {
      type: Object,
      default: () => {}
    },
    movieList: {
      required: true,
      type: Array,
    },
    action: {
      required: true,
      type: String,
    }
  },
  data() {
    return {
      releaseDateTypeOptions,
      comMovieList: [],
    };
  },
  methods: {
    releaseDateChange(num) {
      const { releaseTime } = this.formData;
      let day = releaseTime ? this.$moment(releaseTime) : this.$moment();
      day = day.subtract(-num, "days").format("YYYY-MM-DD");

      this.formData.releaseTime = day;
    },
    movieNameQuery(queryString, cb) {
      let arr = [];
      this.movieList.map(movie => {
        if (movie.name.indexOf(queryString) >= 0) {
          arr.push({
            id: movie.id,
            value: movie.name
          });
        }
      });

      cb(arr);
    },
    selectMovieName(val) {
      const getMovieName = (val) => {
        if (val.indexOf('を新規作成する') > -1) {
          const index = val.indexOf('を新規作成する');
          return val.substr(0, index - 1);
        }
        return val;
      }
      // let curFilm = this.comMovieList.find(item => item.name === val)
      let curFilm = this.$_.omit(this.comMovieList.find(item => item.name === val), [
        'hiddenCms',
        'hiddenPos',
        'hiddenSelfCashier',
        'hiddenWeb',
        'hpRelease',
        'sort',
      ]);
      curFilm = {
        ...this.formData,
        ...curFilm,
        id: "",
        name: getMovieName(val),
      }
      Object.keys(this.formData).forEach(key => {
        this.formData[key] = curFilm[key];
      });
      if (this.formData.hpRelease === null) {
        this.formData.hpRelease = true
      }
      // const selectMovieId = obj.id;

      // getMovieDetail(selectMovieId).then(res => {
      //   if (res.success) {
      //     let targetMovie = res.data;
      //     const tail = this.$locale("movie.movieLand");
      //     const movieName = targetMovie.name.replace(tail, "");

      //     targetMovie = {
      //       ...this.formData,
      //       ...targetMovie,
      //       id: "",
      //       parentFilmId: selectMovieId,
      //       name: movieName,
      //       nationalTicket: [], // remove nationalTicket fisrt, get data from moviTicketList API after
      //     };

      //     Object.keys(this.formData).forEach(key => {
      //       this.formData[key] = targetMovie[key];
      //     });

      //     if (this.formData.national) {
      //       this.$emit("getMoviTicketList");
      //     }
      //   }
      // }).catch(err => {});
    },
    changeMovieName(val) {
      if (this.action === "create" && !val) {
        const initData = initFormData();
        Object.keys(this.formData).forEach(key => {
          this.formData[key] = initData[key];
        });
      }
    },
    openDateTypeChangeAction() {
      this.$nextTick(() => {
        this.formRef.clearValidate("releaseTime");
        this.formRef.clearValidate("openDateStr");
      });

      this.formData.openDateStr = "";
      this.formData.releaseTime = null;
    },
  }
};
</script>